import { isNotWidthPhone } from "@/utils";
import { WECHAT_QQ_LOGIN_ORIGIN } from "@/config";
import { decode } from "js-base64";
export const openQqLogin = () => {
  // QQ 登录地址
  const path = window.location.href;
  const LOGIN_URL = "https://graph.qq.com/oauth2.0/authorize";
  const originalUrl = encodeURIComponent(path);
  // 配置参数
  const CLIENT_ID = "1112443374";
  const REDIRECT_URI = encodeURIComponent(
    `${WECHAT_QQ_LOGIN_ORIGIN}/callback?originalUrl=${originalUrl}&origin=${window.location.origin}&action=loginManager_QQ_PC`
  );
  const qqLoginUrl = `${LOGIN_URL}?response_type=code&client_id=${CLIENT_ID}&state=STATE&scope=get_user_info&redirect_uri=${REDIRECT_URI}`;

  if (isNotWidthPhone()) {
    window.location.href = qqLoginUrl;
    return;
  }

  const dualScreenLeft =
    window.screenLeft !== undefined ? window.screenLeft : 0;
  const dualScreenTop = window.screenTop !== undefined ? window.screenTop : 0;

  const width = window.innerWidth
    ? window.innerWidth
    : document.documentElement.clientWidth
    ? document.documentElement.clientWidth
    : screen.width;
  const height = window.innerHeight
    ? window.innerHeight
    : document.documentElement.clientHeight
    ? document.documentElement.clientHeight
    : screen.height;

  const left = width / 2 - 750 / 2 + dualScreenLeft;
  const top = height / 2 - 470 / 2 + dualScreenTop;
  window.open(
    qqLoginUrl,
    "QQ登录",
    "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=yes, copyhistory=no, width=" +
      750 +
      ", height=" +
      470 +
      ", top=" +
      top +
      ", left=" +
      left
  );
};

export const openWxPcLogin = () => {
  const APPID = "wx5914aaa71f54e467";
  const path = window.location.href;
  const originalUrl = encodeURIComponent(path);
  const REDIRECT_URI = encodeURIComponent(
    `${WECHAT_QQ_LOGIN_ORIGIN}/callback?originalUrl=${originalUrl}&origin=${window.location.origin}&action=loginManager_WX_PC`
  );
  const wxLoginUrl = `https://open.weixin.qq.com/connect/qrconnect?appid=${APPID}&redirect_uri=${REDIRECT_URI}&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect`;

  if (isNotWidthPhone()) {
    window.location.href = wxLoginUrl;
    return;
  }

  const dualScreenLeft =
    window.screenLeft !== undefined ? window.screenLeft : 0;
  const dualScreenTop = window.screenTop !== undefined ? window.screenTop : 0;

  const width = window.innerWidth
    ? window.innerWidth
    : document.documentElement.clientWidth
    ? document.documentElement.clientWidth
    : screen.width;
  const height = window.innerHeight
    ? window.innerHeight
    : document.documentElement.clientHeight
    ? document.documentElement.clientHeight
    : screen.height;

  const left = width / 2 - 750 / 2 + dualScreenLeft;
  const top = height / 2 - 470 / 2 + dualScreenTop;

  window.open(
    wxLoginUrl,
    "微信登录",
    "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=yes, copyhistory=no, width=" +
      750 +
      ", height=" +
      470 +
      ", top=" +
      top +
      ", left=" +
      left
  );
};

// 跳转微信登录
export const openWxLogin = () => {
  const APPID = "wx5914aaa71f54e467";
  const path = WECHAT_QQ_LOGIN_ORIGIN;
  const originalUrl = encodeURIComponent(path);
  const REDIRECT_URI = encodeURIComponent(
    `${WECHAT_QQ_LOGIN_ORIGIN}/callback?originalUrl=${originalUrl}&origin=${window.location.origin}&action=loginManager_WX_PC`
  );
  const wxLoginUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${APPID}&redirect_uri=${REDIRECT_URI}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
  console.log(wxLoginUrl);
  window.location.href = wxLoginUrl;
};

// 储存token
export const setToken = (token) => {
  localStorage.setItem("token", token);
  window.location.reload();
};

// 获取token
export const getToken = () => {
  return localStorage.getItem("token");
};

// 删除token
export const removeToken = () => {
  localStorage.clear();
  window.location.reload();
};

// 设置头像
export const setHeadImg = (headImg) => {
  localStorage.setItem("headImg", headImg);
};

// 解析jwtToken返回data
export const parseJwt = (token) => {
  const base64Url = token.split(".")[1];
  const json = decode(base64Url);
  const obj = JSON.parse(json);
  return obj.data;
};

// 获取用户头像
export const getHeadImg = () => {
  if (!getToken()) return;
  const { avatar } = parseJwt(getToken());
  return avatar;
};

// 获取openid
export const getOpenid = () => {
  if (!getToken()) return;
  const { openid } = parseJwt(getToken());
  console.log(parseJwt(getToken()));
  return openid;
};
